import { render, staticRenderFns } from "./haokaShop.vue?vue&type=template&id=56744ffc&scoped=true&"
import script from "./haokaShop.vue?vue&type=script&lang=js&"
export * from "./haokaShop.vue?vue&type=script&lang=js&"
import style0 from "./haokaShop.vue?vue&type=style&index=0&id=56744ffc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56744ffc",
  null
  
)

export default component.exports